import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { InlineBadge as Badge } from "@dpdgroupuk/react-google-recaptcha-v3";
import clsx from "clsx";
const useStyles = makeStyles(({
  typography
}) => ({
  container: {
    marginTop: 15
  },
  content: {
    display: "inline-block",
    fontSize: typography.pxToRem(12),
    fontWeight: 300,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.5,
    letterSpacing: "normal",
    marginTop: 10,
    opacity: 0.62
  },
  recaptchaLink: {
    textDecoration: "none",
    color: "#1d9ad0"
  }
}));
export const InlineBadge = ({
  classes = {}
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, classes.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.content, classes.content)
  }, /*#__PURE__*/React.createElement(Badge, {
    classes: classes
  })));
};